/**
 * Ce se stie despre un nod de pe harta inainte sa fie scris in inventar.
 * Folosit de panoul "Add to Inventory", ca formularul sa nu porneasca de la zero.
 */

export type Named = { id: number; name: string }

const IPV4 = /^\d{1,3}(?:\.\d{1,3}){3}$/

const TYPE_HINT: Record<string, RegExp> = {
  switch: /switch/i,
  gateway: /router|firewall|gateway|utm|fortigate/i,
  ap: /access\s*point|\bap\b|wireless/i,
}

export function looksLikeIp(value: string): boolean {
  return IPV4.test(value.trim())
}

/** IP-ul pe care harta il stie deja: camp `ip`, eticheta sau subeticheta. */
export function ipFromNode(node: Record<string, unknown>): string {
  for (const raw of [node.ip, node.label, node.sublabel]) {
    const value = raw === null || raw === undefined ? '' : String(raw).trim()
    if (looksLikeIp(value)) return value
  }
  return ''
}

/** Tipul din schema care se potriveste cu felul nodului (switch / gateway / ap). */
export function typeIdForKind(kind: string | undefined, types: Named[]): number | undefined {
  if (!kind) return undefined
  const hint = TYPE_HINT[kind]
  if (!hint) return undefined
  const hit = types.find((t) => hint.test(t.name))
  return hit?.id
}

/** Marca din lista care se potriveste cu vendorul vazut pe retea. */
export function brandIdForVendor(vendor: string, brands: Named[]): number | undefined {
  const needle = vendor.trim().toLowerCase()
  if (!needle) return undefined
  const exact = brands.find((b) => b.name.toLowerCase() === needle)
  if (exact) return exact.id
  const first = needle.split(/\s+/)[0] ?? ''
  const partial = brands.find((b) => {
    const name = b.name.toLowerCase()
    return name.includes(needle) || needle.includes(name) || (first.length > 2 && name.includes(first))
  })
  return partial?.id
}

/**
 * Se poate trece in inventar: nu e deja acolo, e cutie de retea (sau gasit pe
 * retea), nu e internet/retea/iesire publica.
 */
export function canAddToInventory(node: Record<string, unknown>, gear: Record<string, string>): boolean {
  if (node.deviceId) return false
  if (node.public === true) return false
  const kind = typeof node.kind === 'string' ? node.kind : ''
  if (kind === 'internet' || kind === 'network' || kind === 'egress') return false
  if (node.foundId) return true
  return !!gear[kind]
}
